<button class="btn btn-primary btn-lg" (click)="onButtonClick()" [disabled]="disabled">
  <i [attr.class]="cssClass" aria-hidden="true"></i>
</button>
